import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { benchmarkkpi, tranbenchmarkkpi, bmRequest, bmRequestStatusHistroy, recentUpdates } from '../../models/slakpi';
import { division, user, department, targetMaster, benchmarkprogressmaster } from '../../models/admin';
import { outgoingBMRequest } from '../../models/slakpi';
import { UtilityService } from '../../services/utility.service';
import { BMApiService } from '../../services/bm.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import Swal from 'sweetalert2'
import { UserService } from '../../services/user.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { uniqBy } from 'lodash';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  MenuCallbackArgs,

} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AdminApiService } from '../../services/admin.service';
import { ToasterService } from '../../toaster.service';

@Component({
  selector: 'app-recentupdates',
  templateUrl: './recentupdates.component.html',
  styleUrls: ['./recentupdates.component.css']
})
export class RecentUpdatesComponent implements OnInit {
  showMyContainer: boolean = false;
  public gridApi: any;
  public gridColumnApi: any;
  public columnDefs: any;
  public defaultColDef: any;
  public rowData: any;
  public PopoverModule;
  modalRef: BsModalRef;
  @ViewChild('addtemplate', { static: false }) addtemplate: TemplateRef<any>;
  columnDefinitions: Column[];
  histroyColumnDefinitions: Column[];
  gridOptions: GridOption;
  dataset: any;
  public selTab = true;
  public data: any;
  public gridload: number = 0;
  submitted: boolean = false;

  invalid: boolean = false;
  public loading: boolean = true;
  public pageAction: string = 'add';
  objRecentUpdate: any = new recentUpdates();
  angularGrid: AngularGridInstance;
  bmProgressMasterData: object[];
  selected_itemUno: number = 0;
  
    login_UserID: any;
    editID: any;
    searchText: string;
    dataHistroy: any;
  bmRequestStatusHistroyDataSet: any[];
  user: any = {};
  isAdmin: boolean;
  public isBMChampion: boolean = false;
  public isBMTeam: boolean = false;
  public isBMVisitor: boolean = false;
  public isBMAdmin: boolean = false;
    userList: any;
    dataSearch: any[];
  constructor(private formBuilder: FormBuilder, public restApi: AdminApiService,
    public restBMApi: BMApiService,private route: ActivatedRoute,
    public utilityService: UtilityService, private router: Router, private toaster: ToasterService, private spinner: SpinnerVisibilityService, private userService: UserService, private modalService: BsModalService) {
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.ValidateUserAccess();
  }
  //Method used To Validate User Permission

  ValidateUserAccess() {
    

    this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'BM Administrator') ? true : false;

    if (this.user.role == 'BM Champions')
      this.isBMChampion = true;
    if (this.user.role == 'BM Team')
      this.isBMTeam = true;
    if (this.user.role == 'BM Visitor')
      this.isBMVisitor = true;
    if (this.user.role == 'BM Administrator') { this.isBMAdmin = true; }

    if (!this.isAdmin) {
      let userPermissionData = this.userService.getUserRights("BM Request");
      if (userPermissionData != null && userPermissionData != undefined && userPermissionData.length > 0) {
        if (userPermissionData[0].showPage == 1) {

        }
        else {
          this.router.navigateByUrl('/access-denied');
        }
      }
    }

  }

  ngOnInit() {

    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };
    this.userList = this.userService.getUserInfo();
    this.login_UserID = this.userList.id;
    this.searchText = '';
    this.loadRecentUpdate();
   

  }


  
  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }
  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val.trim();
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' ';

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val.trim()
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' ';

  }
  


  setGridRecentUpdateDefn() {
    let temp = this;
    this.columnDefinitions = [
      {
        id: 'title', name: 'Title', field: 'title', sortable: true, type: FieldType.string, filterable: true, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'title', 'title'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'description', name: 'Description', field: 'description', sortable: true, type: FieldType.string, filterable: true, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'description', 'description'),
          model: Filters.multipleSelect,

        }
      },
    

      {
        id: 'action', name: 'Action', field: 'action', cssClass: 'blue', width: 20,
        excludeFromExport: true,
        formatter: this.actionFormatter,
        cellMenu: {
          hideCloseButton: false,
          commandTitleKey: 'COMMANDS',
          commandItems: [
            {
              command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'Edit',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if (this.isBMVisitor)
                  return false;
                else return true;
              },
              iconCssClass: 'fa fa-pencil-square-o', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'edit';
                

                let rdata: any = args.dataContext;
                this.editID = rdata.id;

                this.objRecentUpdate = rdata;
                this.selTab = true;

              

                if (this.pageAction == 'edit') {
                  
                  this.selected_itemUno = rdata.id;
                }
                this.modalRef = this.modalService.show(
                  this.addtemplate,
                  Object.assign({}, { class: 'gray modal-lg' })
                );

              },
              // only show command to 'Delete Row' when the task is not completed

            },
            { divider: true, command: '', positionOrder: 63 },
         
            {
              command: 'delete-row', titleKey: 'DELETE_ROW', positionOrder: 64, title: 'Delete',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if (this.isBMVisitor)
                  return false;
                else return true;
              },
              iconCssClass: 'fa fa-trash', cssClass: 'red', textCssClass: 'bold',
              action: (e, args) => {
                Swal.fire({
                  title: 'Delete',
                  text: 'Please confirm to delete the record',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ok',
                  cancelButtonText: 'Cancel'
                }).then((result) => {
                  if (result.value) {
                    this.pageAction = 'delete';
                    this.DeleteRecentUpdate(args.dataContext);
                  } else if (result.dismiss === Swal.DismissReason.cancel) {

                  }
                })
              },
              // only show command to 'Delete Row' when the task is not completed

            },


          ],
        }
      }

    ]


  }
  
  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
  };

  loadRecentUpdate() {
    this.spinner.show();
    let inpValue = new recentUpdates();
    inpValue.languageUno = 1033;
    inpValue.id = 0;
    inpValue.condition = 0;
    inpValue.userUno = this.login_UserID;

    this.restBMApi.getRecentUpdated(inpValue)
      .subscribe(data => {
        

        this.data = uniqBy(data, 'id');
        const mockDataset = [];
        for (let i = 0; i < this.data.length; i++) {
         
            mockDataset[i] = {
              id: this.data[i].id,
              title: this.data[i].title,
              description: this.data[i].description,
              enteredBy: this.data[i].enteredBy,
              enteredOn: this.data[i].enteredOn,

            };
        }
        this.dataset = mockDataset;
        this.dataSearch = mockDataset;
        if (mockDataset.length > 0) {
          this.setGridRecentUpdateDefn();
        }
        else {
          this.setGridRecentUpdateDefn();
        }
        this.loading = false;
        this.spinner.hide()
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }

  
  openModalWithClass(addtemplate: TemplateRef<any>) {
    
    this.pageAction == "add";
    this.objRecentUpdate = new recentUpdates();

    this.modalRef = this.modalService.show(
      addtemplate,
      Object.assign({}, { class: 'gray modal-lg' })
    );
  }

  onSubmit(val1) {
    
    if (!val1) {
      this.toaster.show('error', 'Error', 'Please enter the required information');
      return
    }

    else {
      this.AddEditRecentUpdate(this.objRecentUpdate)
    }
  }

  AddEditRecentUpdate(data1: any) {
    
   
    //if (this.DuplicateNameCheck(this.utilityService.isNumericNull(data1.id), this.utilityService.isStringNull(data1.bmProgressName), '')) {
    //  Swal.fire('Error', 'Duplicates are not allowed', 'warning');
    //  return false;
    //}

    let obj = new bmRequest();
    obj = data1;
    obj.id = (this.editID) ? this.editID : 0;
    obj.topic = this.objRecentUpdate.title;
    obj.typeDescr = this.objRecentUpdate.description;
    obj.userUno = this.login_UserID;
    obj.condition = (this.editID != null && this.editID != undefined) ? 1 : 0;
    this.restBMApi.addRecentUpdates(obj)
        .subscribe(data => {

          if (data != null && data != undefined && data != '' && data != 'failure') {
            this.toaster.show('success', 'Success', 'Item Saved.');
            setTimeout(() => {
              this.objRecentUpdate = new recentUpdates();
              this.spinner.hide();
              this.loadRecentUpdate();
              this.modalRef.hide();
            }, 500);
           
          }
          else {

            this.toaster.show('error', 'Error', 'Something went wrong');
            this.spinner.hide();

          }



        },
          (error) => {
            //Called when error
            this.spinner.hide();
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
          //this.spinner.hide();
        });
      return true;
   
  }
 


  DeleteRecentUpdate(data1: any) {
    
    let obj = new outgoingBMRequest();
    obj = data1;
    obj.id = data1.id;
    obj.userUno = this.login_UserID;
    obj.condition = 2
    this.restBMApi.addRecentUpdates(obj)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '' && data != 'failure') {
          this.toaster.show('success', 'Success', 'Item Deleted Successfully.');
          this.spinner.hide();
          this.loadRecentUpdate();
        }
        else {
          this.toaster.show('error', 'Error', 'Something went wrong');
          this.spinner.hide();
        }


       
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

  }

 
  
  Reset() {
    this.modalRef.hide();
    setTimeout(() => {
      this.objRecentUpdate = new recentUpdates();
      this.pageAction = 'add';
    }, 300);


  }

  searchGrid() {
    if (this.searchText != "") {
      this.dataset = this.dataSearch.filter(a =>
       (a.title && a.title.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.description && a.description.toLowerCase().includes(this.searchText.toLowerCase()))
       );
    }
    else
      this.dataset = this.dataSearch;
  }
}
